module.exports = __webpack_public_path__ + "img/bg_3.ebc682e2.jpg";